import Api from './Api/index'

export default [
  { value: Api }
]
